/**
 * Utility functions for converting numbers to Persian digits
 */

const persianToEnglish: { [key: string]: string } = {
  '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
  '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
  '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
  '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
};

export function toEnglishNumber(input: string | number): string {
  const str = String(input);
  return str.replace(/[۰-۹٠-٩]/g, (digit) => persianToEnglish[digit] || digit);
}

const englishToPersian: { [key: string]: string } = {
  '0': '۰',
  '1': '۱',
  '2': '۲',
  '3': '۳',
  '4': '۴',
  '5': '۵',
  '6': '۶',
  '7': '۷',
  '8': '۸',
  '9': '۹',
};

/**
 * Converts English digits in a string to Persian digits
 */
export function toPersianNumber(input: string | number): string {
  const str = String(input);
  return str.replace(/[0-9]/g, (digit) => englishToPersian[digit] || digit);
}

/**
 * Formats a number with Persian digits and thousand separators
 */
export function formatPersianNumber(num: number | null | undefined, decimals: number = 0): string {
  if (num === null || num === undefined) {
    return '-';
  }
  
  const formatted = num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  
  return toPersianNumber(formatted);
}

